__turbopack_context__.v({
  "time": "TimeRange-module-scss-module__lfbIba__time",
  "timeRange": "TimeRange-module-scss-module__lfbIba__timeRange",
});
